// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getClaimTypes} from '../../../shared/repositories';

export const readClaimTypes = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const claimTypes = await getClaimTypes();

            dispatch({
                claimTypes,
                type: actions.READ_CREDIT_MEMO_CLAIM_TYPES
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };




// WEBPACK FOOTER //
// ./src/reports/credit-memo/action-creators/read-claim-types.js